import { useCallback } from "react";
import { useQuery, useLazyQuery } from "@apollo/client";

import { FETCH_ENTITIES } from "../graphql/query/Entity";

export const useEntities = (props = {}) => {
  const { data = {}, loading, error } = useQuery(FETCH_ENTITIES, props);
  const { entities = {} } = data;

  const findEntityById = useCallback(
    id => {
      return entities.edges?.find(entity => entity.id === id);
    },
    [entities],
  );

  const findEntityByName = useCallback(
    name => {
      return entities.edges?.find(entity => entity.name === name);
    },
    [entities],
  );

  return {
    error,
    loading,
    entities,
    findEntityById,
    findEntityByName,
  };
};

export const useEntitiesLazy = (props = {}) => {
  const [fetchEntities, { data = {}, loading, error }] =
    useLazyQuery(FETCH_ENTITIES);
  const { entities = {} } = data;

  const findEntityById = useCallback(
    id => {
      return entities.edges?.find(entity => entity.id === id);
    },
    [entities],
  );

  const findEntityByName = useCallback(
    name => {
      return entities.edges?.find(entity => entity.name === name);
    },
    [entities],
  );

  return [
    () => fetchEntities(props),
    { error, loading, entities, findEntityById, findEntityByName },
  ];
};
